"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var logistics = _interopRequireWildcard(require("@/api/logistics"));
var _elementUi = require("element-ui");
var _validate = require("@/utils/validate");
var selfUtil = _interopRequireWildcard(require("@/utils/ZBKJIutil.js"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var defaultRole = {
  name: '',
  type: 1,
  appoint: 0,
  sort: 0,
  region: [{
    first: 1,
    firstPrice: 0,
    renewal: 0,
    renewalPrice: 0,
    city_ids: [],
    cityId: 0
  }],
  undelivery: 0,
  free: [],
  undelives: {}
};
var kg = '重量（kg）';
var m = '体积（m³）';
var statusMap = [{
  title: '首件',
  title2: '续件',
  title3: '包邮件数'
}, {
  title: "\u9996\u4EF6".concat(kg),
  title2: "\u7EED\u4EF6".concat(kg),
  title3: "\u5305\u90AE".concat(kg)
}, {
  title: "\u9996\u4EF6".concat(m),
  title2: "\u7EED\u4EF6".concat(m),
  title3: "\u5305\u90AE".concat(m)
}];
var _default = exports.default = {
  name: 'CreatTemplates',
  components: {},
  data: function data() {
    return {
      loading: false,
      rules: {
        name: [{
          required: true,
          message: '请输入模板名称',
          trigger: 'blur'
        }],
        free: [{
          type: 'array',
          required: true,
          message: '请至少添加一个区域',
          trigger: 'change'
        }],
        appoint: [{
          required: true,
          message: '请选择包邮方式',
          trigger: 'change'
        }],
        undelivery: [{
          required: true,
          message: '请选择是否指定区域不配送',
          trigger: 'change'
        }],
        type: [{
          required: true,
          message: '请选择计费方式',
          trigger: 'change'
        }],
        region: [{
          required: true,
          message: '请选择区域运费',
          trigger: 'change'
        }],
        city_ids: [{
          type: 'array',
          required: true,
          message: '请至少选择一个区域',
          trigger: 'change'
        }],
        first: [{
          required: true,
          message: '请输入',
          trigger: 'blur'
        }],
        renewal: [{
          required: true,
          message: '请输入',
          trigger: 'blur'
        }],
        firstPrice: [{
          required: true,
          message: '请输入运费',
          trigger: 'blur'
        }],
        renewalPrice: [{
          required: true,
          message: '请输入续费',
          trigger: 'blur'
        }]
      },
      nodeKey: 'city_ids',
      props: {
        children: 'child',
        label: 'regionName',
        value: 'regionId',
        multiple: true
      },
      dialogVisible: false,
      ruleForm: Object.assign({}, defaultRole),
      listLoading: false,
      cityList: [],
      columns: {
        title: '首件',
        title2: '续件',
        title3: '包邮件数'
      },
      tempId: 0,
      regionNew: [{
        first: 1,
        firstPrice: 0,
        renewal: 0,
        renewalPrice: 0,
        city_ids: [],
        cityId: 0
      }],
      type: 0 // 0添加 1编辑
    };
  },
  mounted: function mounted() {
    var cityList = localStorage.getItem('cityList') ? JSON.parse(localStorage.getItem('cityList')) : [];
    // this.cityList = this.changeNodes(cityList);
    this.cityList = this.changeNodes(cityList);
  },
  methods: {
    changeAppoint: function changeAppoint() {
      var region = _toConsumableArray(this.ruleForm.region);
    },
    changType: function changType(type) {
      this.type = type;
    },
    confirmEdit: function confirmEdit(row, index) {
      row.splice(index, 1);
    },
    popoverHide: function popoverHide() {},
    handleClose: function handleClose() {
      var _this = this;
      this.dialogVisible = false;
      setTimeout(function () {
        _this.ruleForm = {
          name: '',
          type: 1,
          appoint: 0,
          sort: 0,
          region: [{
            first: 0,
            firstPrice: 0,
            renewal: 0,
            renewalPrice: 0,
            city_ids: [],
            cityId: 0
          }],
          undelivery: 0,
          free: [],
          undelives: {}
        };
      }, 1000);
      this.columns = Object.assign({}, statusMap[0]);
    },
    changeNodes: function changeNodes(data) {
      if (data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          if (!data[i].child || data[i].child.length < 1) {
            // this.$delete(data[i], 'child');
            data[i].child = undefined;
          } else {
            this.changeNodes(data[i].child);
          }
        }
      }
      return data;
    },
    changeRegion: function changeRegion(value) {
      // let val = value;
      // let attr = JSON.parse(JSON.stringify(val));
      // for (var i = 0; i < attr.length; i++) {
      //   attr[i].splice(0, 2);
      // }
      // let cityTree = attr.flat();
      // for (var i = 0; i < this.cityList.length; i++) {
      //   for (var j = 0; j < this.cityList[i].child.length; j++) {
      //     for (var w = 0; w < this.cityList[i].child[j].child.length; w++) {
      //       if (!this.cityList[i].child[j].child[w]) return;
      //       if (cityTree.includes(this.cityList[i].child[j].child[w].regionId)) {
      //         this.cityList[i].child[j].child[w].disabled = true;
      //       }
      //     }
      //   }
      // }
    },
    judgeDisabled: function judgeDisabled(cityList, cityTree) {
      var _this2 = this;
      cityList.map(function (item, index) {
        item.disabled = item.regionId === cityTree[index];
        if (item.child && item.child.length) {
          _this2.judgeDisabled(item.child);
        }
      });
    },
    changeRadio: function changeRadio(num) {
      this.columns = Object.assign({}, statusMap[num - 1]);
    },
    // 添加配送区域
    addRegion: function addRegion(region) {
      region.push(Object.assign({}, {
        first: 0,
        firstPrice: 0,
        renewal: 0,
        renewalPrice: 0,
        city_ids: [],
        cityId: ''
      }));
    },
    addFree: function addFree(Free) {
      Free.push(Object.assign({}, {
        number: 1,
        price: 1,
        city_ids: [],
        cityId: ''
      }));
    },
    /**
     * 详情
     * id 模板id
     * appoint true包邮 false不包邮
     **/
    getInfo: function getInfo(id, appoint) {
      var _this3 = this;
      this.tempId = id;
      var loadingInstance = _elementUi.Loading.service({
        fullscreen: true
      });
      logistics.templateDetailApi({
        id: id
      }).then(function (res) {
        _this3.dialogVisible = true;
        var info = res;
        if (info.appoint === 0) info.type = 1;
        if (Number(info.appoint) > 0) {
          if (info.regionList && info.regionList.length > 0) {
            info.regionList.forEach(function (item, index) {
              item.title = JSON.parse(item.title);
              item.city_ids = item.title;
            });
          }
          if (info.freeList && info.freeList.length > 0) {
            info.freeList.forEach(function (item, index) {
              item.title = JSON.parse(item.title);
              item.city_ids = item.title;
            });
          }
        }
        _this3.ruleForm = Object.assign(_this3.ruleForm, {
          name: info.name,
          type: info.type,
          appoint: info.appoint,
          sort: info.sort,
          region: info.regionList || [],
          // 运费区域
          free: info.freeList || [] // 包邮区域
        });
        _this3.regionNew = _toConsumableArray(_this3.ruleForm.region);
        _this3.columns = Object.assign({}, statusMap[_this3.ruleForm.type - 1]);
        _this3.$nextTick(function () {
          loadingInstance.close();
        });
      }).catch(function (res) {
        // console.integralLog(res)
        _this3.$message.error(res.message);
        _this3.$nextTick(function () {
          loadingInstance.close();
        });
      });
    },
    // 列表
    getCityList: function getCityList() {
      var _this4 = this;
      logistics.cityListTree().then(function (res) {
        localStorage.setItem('cityList', JSON.stringify(res));
        var cityList = JSON.parse(localStorage.getItem('cityList'));
        _this4.cityList = cityList;
        _this4.changeNodes(cityList);
      }).catch(function (res) {
        _this4.$message.error(res.message);
      });
    },
    change: function change(idBox) {
      idBox.map(function (item) {
        var ids = [];
        item.city_ids.map(function (j) {
          j.splice(0, 1);
          ids.push(j[0]);
        });
        item.city_ids = ids;
      });
      return idBox;
    },
    changeOne: function changeOne(idBox) {
      var city_ids = [];
      idBox.map(function (item) {
        item.splice(0, 1);
        city_ids.push(item[0]);
      });
      return city_ids;
    },
    onsubmit: (0, _validate.Debounce)(function (formName) {
      var _this5 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this5.loading = true;
          var param = {
            appoint: _this5.ruleForm.appoint,
            name: _this5.ruleForm.name,
            sort: _this5.ruleForm.sort,
            type: _this5.ruleForm.type,
            // 配送区域及运费
            shippingTemplatesRegionRequestList: [],
            // 指定包邮设置
            shippingTemplatesFreeRequestList: [],
            id: _this5.tempId
          };
          _this5.ruleForm.region.forEach(function (el, index) {
            el.title = el.city_ids.length > 0 ? JSON.stringify(el.city_ids) : JSON.stringify([[0, 0]]);
            if (el.title === '[[0,0]]') {
              el.cityId = '0';
            } else {
              for (var i = 0; i < el.city_ids.length; i++) {
                el.city_ids[i].splice(0, 2);
              }
              el.cityId = el.city_ids.length > 0 ? el.city_ids.join(',') : '0';
            }
          });
          param.shippingTemplatesRegionRequestList = _this5.ruleForm.region;
          param.shippingTemplatesRegionRequestList.forEach(function (el, index) {
            _this5.$delete(el, 'city_ids');
          });
          _this5.ruleForm.free.forEach(function (el, index) {
            el.title = el.city_ids.length > 0 ? JSON.stringify(el.city_ids) : JSON.stringify([[0, 0]]);
            if (el.title === '[[0,0]]') {
              el.cityId = '0';
            } else {
              for (var i = 0; i < el.city_ids.length; i++) {
                el.city_ids[i].splice(0, 2);
              }
              el.cityId = el.city_ids.length > 0 ? el.city_ids.join(',') : '0';
            }
          });
          param.shippingTemplatesFreeRequestList = _this5.ruleForm.free;
          param.shippingTemplatesFreeRequestList.forEach(function (el, index) {
            _this5.$delete(el, 'city_ids');
          });
          if (_this5.ruleForm.appoint === 2) {
            _this5.ruleForm.region.map(function (item, index) {
              _this5.ruleForm.region[0].title = '[[0,0]]';
              _this5.ruleForm.region[0].cityId = '0';
            });
          }
          if (_this5.ruleForm.appoint === 0) {
            _this5.$delete(param, 'shippingTemplatesRegionRequestList');
            _this5.$delete(param, 'shippingTemplatesFreeRequestList');
            _this5.ruleForm.type = 0;
          }
          if (_this5.type === 0) {
            logistics.shippingSave(param).then(function (res) {
              _this5.$message.success('操作成功');
              _this5.$emit('getList');
              _this5.loading = false;
              _this5.$store.commit('product/SET_ShippingTemplates', []);
              _this5.handleClose();
            }).catch(function () {
              _this5.loading = false;
            });
          } else {
            logistics.shippingUpdate(param).then(function (res) {
              _this5.$message.success('操作成功');
              _this5.$store.commit('product/SET_ShippingTemplates', []);
              _this5.$emit('getList');
              _this5.handleClose();
              _this5.loading = false;
            }).catch(function () {
              _this5.loading = false;
            });
          }
        } else {
          return false;
        }
      });
    }),
    clear: function clear() {
      this.ruleForm.name = '';
      this.ruleForm.sort = 0;
    }
  }
};